export default __webpack_public_path__ + "static/media/5.bf66d884.jpg";